import { assign, createMachine } from '@monofront/xstate-v4';
import { SELECT_PICKUP_POINT_TRANSITIONS } from './transitions';
import { SELECT_PICKUP_POINT_STATES } from './states';
import {
  ISelectPickupPointContext,
  ISelectPickupPointEvents,
  ISelectPickupPointServices,
} from './types';
import {
  assignInitValuesForModal,
  assignPickupSelected,
  SELECT_PICKUP_POINT_EXTERNAL_ACTIONS,
  sendPickupSelectedToParent,
} from './actions';
import { SELECT_PICKUP_POINT_EXTERNAL_SERVICES } from './services';

export const SELECT_PICKUP_POINT_MACHINE_ID = 'select-pickup-point';

export const selectPickupPointMachine = createMachine<
  ISelectPickupPointContext,
  ISelectPickupPointEvents
>({
  predictableActionArguments: true,
  id: SELECT_PICKUP_POINT_MACHINE_ID,
  initial: SELECT_PICKUP_POINT_STATES.CLOSED,
  schema: {
    context: {} as ISelectPickupPointContext,
    events: {} as ISelectPickupPointEvents,
    services: {} as ISelectPickupPointServices,
  },
  context: {
    pickupPoints: [],
    shippingMethods: [],
    pickupPointSelected: null,
    address: null,
    pickupAddress: null,
    shipmentMethodCode: null,
  },
  states: {
    [SELECT_PICKUP_POINT_STATES.CLOSED]: {
      on: {
        [SELECT_PICKUP_POINT_TRANSITIONS.OPEN]: {
          target: SELECT_PICKUP_POINT_STATES.OPENED,
          actions: [
            SELECT_PICKUP_POINT_EXTERNAL_ACTIONS.trackOpenModal,
            assignInitValuesForModal,
          ],
        },
      },
    },
    [SELECT_PICKUP_POINT_STATES.OPENED]: {
      initial: SELECT_PICKUP_POINT_STATES.POINTS_FETCHING,
      states: {
        [SELECT_PICKUP_POINT_STATES.POINTS_FETCHING]: {
          invoke: {
            src: SELECT_PICKUP_POINT_EXTERNAL_SERVICES.listPickupPoints,
            onDone: [
              {
                target: SELECT_PICKUP_POINT_STATES.GET_SUCCESS,
                actions: [
                  assign({
                    pickupPoints: (_, event) => event.data.pickupList,
                    homePosition: (_, event) => event.data.homePosition,
                  }),
                ],
              },
            ],
            onError: SELECT_PICKUP_POINT_STATES.GET_ERROR,
          },
          on: {
            [SELECT_PICKUP_POINT_TRANSITIONS.CLOSE]: {
              target: `#${SELECT_PICKUP_POINT_MACHINE_ID}.${SELECT_PICKUP_POINT_STATES.CLOSED}`,
              actions: [SELECT_PICKUP_POINT_EXTERNAL_ACTIONS.trackCloseModal],
            },
          },
        },
        [SELECT_PICKUP_POINT_STATES.GET_ERROR]: {
          on: {
            [SELECT_PICKUP_POINT_TRANSITIONS.FETCH_POINTS]:
              SELECT_PICKUP_POINT_STATES.POINTS_FETCHING,
            [SELECT_PICKUP_POINT_TRANSITIONS.CLOSE]: {
              target: `#${SELECT_PICKUP_POINT_MACHINE_ID}.${SELECT_PICKUP_POINT_STATES.CLOSED}`,
              actions: [SELECT_PICKUP_POINT_EXTERNAL_ACTIONS.trackCloseModal],
            },
          },
        },
        [SELECT_PICKUP_POINT_STATES.GET_SUCCESS]: {
          on: {
            [SELECT_PICKUP_POINT_TRANSITIONS.CLOSE]: {
              target: `#${SELECT_PICKUP_POINT_MACHINE_ID}.${SELECT_PICKUP_POINT_STATES.CLOSED}`,
              actions: [SELECT_PICKUP_POINT_EXTERNAL_ACTIONS.trackCloseModal],
            },
            [SELECT_PICKUP_POINT_TRANSITIONS.FETCH_POINTS]:
              SELECT_PICKUP_POINT_STATES.POINTS_FETCHING,
            [SELECT_PICKUP_POINT_TRANSITIONS.SELECT_POINT]: {
              actions: [
                SELECT_PICKUP_POINT_EXTERNAL_ACTIONS.trackCloseModal,
                assignPickupSelected,
                sendPickupSelectedToParent,
              ],

              target: `#${SELECT_PICKUP_POINT_MACHINE_ID}.${SELECT_PICKUP_POINT_STATES.CLOSED}`,
            },
          },
        },
      },
    },
  },
});
